import React from 'react';
import PropTypes from 'prop-types';

import styles from './ListRow.scss';
import ListColumn from 'Components/ListColumn/ListColumn';

const ListRow = ({
  data,
  id,
  isNew,
  isHeader,
  actions,
  status,
  style,
  additionalClassNames,
  children,
  columnSizes,
  columnIds,
  rowSize,
}) => {
  const columnsWithSortValues = [
    'trial_remaining',
    'last_login_at',
    'admin_last_login',
    'license_end',
  ];

  if (!data) return null;

  const showSkeleton =
    data.length === 0 && Array.isArray(columnIds) && !isHeader;
  const containerChildren = showSkeleton
    ? columnIds.map(key => (
        <div
          className="ListColumn"
          key={`skeleton-${key}`}
          data-size={columnSizes[key]}
        />
      ))
    : [
        children,
        data.map(({ key, value }) => (
          <ListColumn
            key={`column-${key}`}
            id={key}
            sortValue={
              columnsWithSortValues.includes(key) ? value.sortable : null
            }
            size={columnSizes[key]}
          >
            {columnsWithSortValues.includes(key) ? value.visible : value}
          </ListColumn>
        )),
      ];

  return (
    <div
      className={`ListRow ${additionalClassNames}${
        showSkeleton ? ' ListRow--skeleton' : ''
      }`}
      data-id={id}
      data-status={status}
      data-new={isNew ? 'true' : null}
      data-size={rowSize}
      style={style}
    >
      <div className="ListRow__container">{containerChildren}</div>
      {actions}
    </div>
  );
};

ListRow.propTypes = {
  data: PropTypes.array,
  children: PropTypes.node,
  id: PropTypes.string,
  isNew: PropTypes.bool,
  isHeader: PropTypes.bool,
  additionalClassNames: PropTypes.string,
  actions: PropTypes.element,
  style: PropTypes.object,
  columnIds: PropTypes.array,
  columnSizes: PropTypes.object,
  /**
   * Medium: used for lists with sidebars and no x-axis scroll
   * Large: used for full-width lists
   * Auto: It should be sized naturally by the width of the columns
   */
  rowSize: PropTypes.oneOf(['med', 'lg', 'auto']),
  status: PropTypes.oneOf(['invited', 'deactivated']),
};

ListRow.defaultProps = {
  isNew: false,
  rowSize: 'lg',
  isHeader: false,
  data: [],
  additionalClassNames: '',
};

export default ListRow;
